import { isEmpty } from 'oderon-commons/src/utils'
import _ from 'lodash'

export default function strCriteria(crit, html = false) {
  let result = []
  if (!isEmpty(crit.sources))
    result.push(`das origens: ` + join(crit.sources, html, 'green'))

  if (!isEmpty(crit.withoutSources))
    result.push(`sem as origens: ` + join(crit.withoutSources, html, 'red'))

  if (!isEmpty(crit.tags))
    result.push(`com as tags: ` + join(crit.tags, html, 'green'))

  if (!isEmpty(crit.withoutTags))
    result.push(`sem as tags: ` + join(crit.withoutTags, html, 'red'))

  if (result.length < 1) return '(nada)'

  result = _.upperFirst(result.join(', '))
  if (!html) {
    return result
  } else {
    return { html: result }
  }
}

function join(arr, html, color = '') {
  if (!html) return arr.join(', ')

  let result = arr.map(x => `<span class="tag ${color}">${x}</span>`)
  return result.join(' ')
}
